import { Action, createReducer, on } from '@ngrx/store';
import { ICheckCardStatusRequest, ICheckCardStatusResponse } from '../models/check-card-status.model';
import * as fromCheckCardStatusActions from '../actions';

export const checkCardStatusFeatureKey = 'checkCardStatus';

export interface CheckCardStatusState {
  loadCheckCardStatusRequest: ICheckCardStatusRequest;
  loadCheckCardStatusResponse: ICheckCardStatusResponse;
  loadCheckCardStatusFailure: Error | any;
}

export const initialState: CheckCardStatusState = {
  loadCheckCardStatusRequest: undefined,
  loadCheckCardStatusResponse: undefined,
  loadCheckCardStatusFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromCheckCardStatusActions.loadCheckCardStatus, (state, action) => ({
    ...state,
    loadCheckCardStatusRequest: action.request
  })),

  on(fromCheckCardStatusActions.loadCheckCardStatusSuccess, (state, action) => ({
    ...state,
    loadCheckCardStatusResponse: action.response
  })),

  on(fromCheckCardStatusActions.loadCheckCardStatusFailure, (state, action) => ({
    ...state,
    loadCheckCardStatusFailure: action.error
  }))
);

export const getCheckCardStatusResponse = (state: CheckCardStatusState) => state.loadCheckCardStatusResponse;
